import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, retry } from 'rxjs';
import { County } from '../models/county.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountyService {
  private apiUrl = `${environment.apiUrl}/county`;

  constructor(private http: HttpClient) {}

  getAllCounties(): Observable<County[]> {
    return this.http.get<County[]>(this.apiUrl).pipe(retry(2));
  }

  getCountyById(id: string): Observable<County> {
    return this.http.get<County>(`${this.apiUrl}/${id}`).pipe(retry(2));
  }

  createCounty(county: County): Observable<County> {
    return this.http.post<County>(this.apiUrl, county);
  }

  updateCounty(id: string, county: County): Observable<County> {
    return this.http.put<County>(`${this.apiUrl}/${id}`, county);
  }

  deleteCounty(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}